import { Role } from '@web/shared/module/auth';

export const isUnavailableRole = (role: Role): boolean => {
  const unavailableRoles = [Role.User, Role.Subscriber];

  return unavailableRoles.includes(role);
};
